import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 6v12h-.89c-3.34 0 -6.047 -2.686 -6.047 -6s2.707 -6 6.046 -6h.891","key":"svg-0"}],["path",{"d":"M3.063 6v12h.891c3.34 0 6.046 -2.686 6.046 -6s-2.707 -6 -6.046 -6h-.89","key":"svg-1"}]]

const IconBrandDolbyDigital = createReactComponent('outline', 'brand-dolby-digital', 'BrandDolbyDigital', __iconNode);

export default IconBrandDolbyDigital;